import { IconButton } from '../Button';
import { HStack } from '../Core';
import { IconName } from '../Icons';
import { Text } from '../Text';

interface StepperProps {
  /** The current index */
  index: number;
  /** Called when the user steps in either direction */
  onChange: (newIndex: number) => void;
  /** The items the user can step between. Essentially just tells the component how many steps are available. */
  items: unknown[];
}

/**
 * A very simple controlled-state component which just renders two arrows, one left and one right, allowing you to
 * step through some array of items.
 */
export const Stepper = ({ index, items, onChange }: StepperProps) => {
  const leftDisabled = index === 0;
  const rightDisabled = index === items.length - 1;

  return (
    <HStack gap="spacing8">
      <Text whiteSpace="nowrap">
        Showing {index + 1} / {items.length}
      </Text>
      <IconButton
        icon={IconName.ArrowLeft}
        disabled={leftDisabled}
        onClick={() => onChange(index - 1)}
        data-testid="stepper-prev"
      />
      <IconButton
        icon={IconName.ArrowRight}
        disabled={rightDisabled}
        onClick={() => onChange(index + 1)}
        data-testid="stepper-next"
      />
    </HStack>
  );
};
